<template>
  <div class="flex-fill">
    <ul :class="setSidebarColors">
      <li class="nav-item" v-for="property in navMenuProperties">
        <router-link v-if="!property.isExternal" class="nav-link" data-placement="bottom" :title="property.title"
                     :to="property.to">{{ property.title }}</router-link>
        <a v-else class="nav-link" data-placement="bottom" :title="property.title"
           :href="property.to" target="_blank">{{ property.title }}</a>
      </li>
    </ul>
  </div>

</template>

<script>
export default {
  name: "NavMenu",
  props: {
    select: {
      type: String,
      default: null
    },
    exclude: {
      type: String,
      default: null
    },
    isSidebar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isValidate(){
      return this.$store.getters.getUserAfm !== "";
    },
    setSidebarColors() {
      return "navbar-nav mr-auto " + (this.isSidebar ?  "sidebar-links": "guest-links")
    }
  },
  methods: {
    selection: function () {
      if(this.select)
        this.navMenuProperties = this.navMenuProperties.filter((prop) => prop.title === this.select)
    },
    exclusion: function () {
      if(this.exclude)
        this.navMenuProperties = this.navMenuProperties.filter((prop) => prop.title !== this.exclude)
    }
  },
  data() {
    return {
      navMenuProperties: [
        {
          title: "Αρχική Σελίδα",
          to: "",
          isExternal: false
        },
        {
          title: "Συχνές Ερωτήσεις(FAQ)",
          to: "/faq",
          isExternal: false
        },
        {
          title: "Οδηγίες",
          to: "/files/efedros user manual.pdf",
          isExternal: true
        },
        {
          title: "Πολιτική Απορρήτου",
          to: "/data-privacy",
          isExternal: false
        },
        // {
        //   title: "Ιστορικό Εκδόσεων",
        //   to: "/edit-history",
        //   isExternal: false
        // }
      ]
    }
  },
  beforeMount() {
    // Switching :to property of app logo router link to redirect a non validated user for validation
    this.navMenuProperties[0].to = this.isValidate ? '/validate':'/'
    this.selection()
    this.exclusion()
  }
}
</script>
